import { Injectable } from '@angular/core';
import { MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs';

import { OriginalPricingResponse } from '@app/api/models';
import { PricingService } from '@app/api/services';
import { DialogService } from '@shared/services/dialog.service';

import { VipDiscountsOriginalPricesModalComponent } from '../components/vip-discounts-original-prices-modal/vip-discounts-original-prices-modal.component';
import { VipDiscountsActions } from './vip-discounts.slice';

@Injectable({ providedIn: 'root' })
export class VipDiscountsEffects {
  loadOriginalPrice$ = createEffect(() =>
    this.actions$.pipe(
      ofType(VipDiscountsActions.loadOriginalPrice.trigger),
      switchMap((action) =>
        this.pricingService
          .getOriginalPricing({
            productSortimentId: action.discount.sortimentId ?? '',
            isRequestedAsDiscountReceiver: action.isRequestedAsDiscountReceiver,
          })
          .pipe(
            map((response: OriginalPricingResponse) => {
              const dialogConfig: MatDialogConfig = {
                panelClass: 'original-price-modal',
                width: '80%',
                minHeight: 'unset',
                data: {
                  product: response,
                  discount: action.discount,
                },
              };
              this.dialogService.openDialog(
                VipDiscountsOriginalPricesModalComponent,
                dialogConfig
              );
              return VipDiscountsActions.loadOriginalPrice.success();
            })
          )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private router: Router,
    private readonly pricingService: PricingService,
    private dialogService: DialogService
  ) {}
}
